unit TypeListType;
{

/* Initial. */

}
interface

uses
  JS,
  TypeType;

type
  TTypeArray = array of TTypeType;

  TTypeListType = class
    fTypeArray: TTypeArray;
  public
    property TypeArray: TTypeArray read fTypeArray;
    constructor Create(const String_JSON: String);
  end;

implementation

constructor TTypeListType.Create(const String_JSON: String);
var JSArray_ListType: TJSArray;
    JSValue_Type: JSValue;
    TypeType: TTypeType;
begin
  if String_JSON <> 'null' then
  begin
    JSArray_ListType := TJSArray(TJSJSON.parseobject(String_JSON));

    for JSValue_Type in JSArray_ListType do
    begin
      TypeType := TTypeType.Create(TJSJSON.stringify(JSValue_Type));

      Insert(TypeType, fTypeArray, High(fTypeArray));
    end;
  end;
end;

end.
